import { render, staticRenderFns } from "./PopupDialogComponent.vue?vue&type=template&id=115b2c53&scoped=true&"
import script from "./PopupDialogComponent.vue?vue&type=script&lang=js&"
export * from "./PopupDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialogComponent.vue?vue&type=style&index=0&id=115b2c53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b2c53",
  null
  
)

export default component.exports